import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(() => ({
	popperContainer: {
		padding: 16
	}
}))

export default useStyles
